import { GoogleMap } from "./GoogleMap";
import { GoogleMapScript } from "./GoogleMapScript";

export default GoogleMap;
export { GoogleMapScript };
